import clsx from "clsx";
import { useEffect, useState } from "react";
import useUnit from "../../../../../../../../../hooks/UseUnit";
import { Unit } from "../../../../../../../../types/project";
import styles from "./UnitEditor.module.scss";

export default function UnitEditor({
  activeUnit,
}: {
  activeUnit: Unit;
}): JSX.Element {
  const [name, setName] = useState(activeUnit.name);
  const [hp, setHP] = useState(activeUnit.hp);

  const { updateUnit, status, data: dbUnit } = useUnit({ id: activeUnit.id });

  useEffect(() => {
    setName(activeUnit.name);
    setHP(activeUnit.hp);
  }, [activeUnit.id]);

  useEffect(() => {
    updateUnit({
      unitId: activeUnit.id,
      values: {
        name,
        hp,
      },
    });
  }, [name, hp]);

  if (status !== "success") {
    <></>;
  }

  return (
    <div className={styles.editorContainer}>
      <div className={styles.elementName}>{dbUnit.name}</div>
      <div className={styles.label}>Name</div>
      <input
        className={styles.input}
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
      />
      <div className={styles.label}>HP</div>
      <input
        className={styles.input}
        value={hp}
        type="number"
        onChange={(e) => {
          setHP(Number(e.target.value));
        }}
      />
    </div>
  );
}
